import { StructureModel } from "@dataspecer/core/structure-model/model";
/**
 * Structure model for XML schemas.
 */
export class XmlStructureModel extends StructureModel {
    namespace = null;
    namespacePrefix = null;
    skipRootElement = false;
}
//# sourceMappingURL=xml-structure-model.js.map